import { isNonEmptyStringOrNumber } from '@thesavingsgroup/utils/isNonEmptyStringOrNumber';

import { DashboardVehicle } from '../../dashboardStore/types/DashboardVehicle';
import { SearchVehicle } from '../enums/SearchVehicle';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromVehicleSelection } from '../types/HydrateFromVehicleSelection';
import { VehicleIdentifiers } from '../types/VehicleIdentifiers';

export const toApplyStateFromVehicleSelection = async (
  vehicleSelection: HydrateFromVehicleSelection,
  findVehicleSelectionById: (id: string) => DashboardVehicle | undefined,
  fetchVehicleIdentifiers: (
    vehicle: DashboardVehicle,
  ) => Promise<VehicleIdentifiers>,
): Promise<Partial<ApplyState>> => {
  const vehicle = findVehicleSelectionById(vehicleSelection.vehicleSelectionId);

  if (!vehicle) {
    return {};
  }

  const { make, model, trim, year } = await fetchVehicleIdentifiers(vehicle);

  const mileage = isNonEmptyStringOrNumber(vehicle.mileage)
    ? String(vehicle.mileage)
    : null;
  const payoffAmount = isNonEmptyStringOrNumber(vehicle.payoffAmount)
    ? String(vehicle.payoffAmount)
    : null;

  let searchVehicle: SearchVehicle;

  if (vehicle.vin) {
    searchVehicle = SearchVehicle.BY_VIN;
  } else if (vehicle.plate && vehicle.province) {
    searchVehicle = SearchVehicle.BY_LICENSE_PLATE;
  } else {
    searchVehicle = SearchVehicle.BY_MAKE_MODEL;
  }

  return {
    make,
    mileage,
    model,
    payoffAmount,
    plate: vehicle.plate,
    searchVehicle,
    state: vehicle.province,
    trim,
    vin: vehicle.vin,
    year,
  };
};
